const ASSET_BASE = "https://customer-assets-jt897jd0.emergentagent.net/job_987c5779-2c0c-444b-81da-e197b6cf1844/artifacts";

export const BRAND = {
  coinLogo: `${ASSET_BASE}/8y4om07a_1790380195491.jpg`,
  banner: `${ASSET_BASE}/jhpruxne_1790394887186.jpg`,
  founders: `${ASSET_BASE}/2maqeak3_1790539013611.jpg`,
};

export const IMAGES = {
  studioConsole1: "https://images.unsplash.com/photo-1518972559570-7cc1309f3229?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxyZWNvcmRpbmclMjBzdHVkaW8lMjBjb25zb2xlfGVufDB8fHx8MTc5MDU2MTYxOXww&ixlib=rb-4.1.0&q=85",
  studioConsole2: "https://images.unsplash.com/photo-1618609377864-68609b857e90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxyZWNvcmRpbmclMjBzdHVkaW8lMjBjb25zb2xlfGVufDB8fHx8MTc5MDU2MTYxOXww&ixlib=rb-4.1.0&q=85",
  studioNeon: "https://images.unsplash.com/photo-1741745977996-d9d9047f98db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwyfHxoaXAlMjBob3AlMjBzdHVkaW8lMjBuZW9ufGVufDB8fHx8MTc5MDU2MTYxOXww&ixlib=rb-4.1.0&q=85",
  studioHeadphones: "https://images.unsplash.com/photo-1741745978060-9add161ba2c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxoaXAlMjBob3AlMjBzdHVkaW8lMjBuZW9ufGVufDB8fHx8MTc5MDU2MTYxOXww&ixlib=rb-4.1.0&q=85",
};

export const MERCH = {
  hoodie: "https://images.unsplash.com/photo-1647610229306-3906b8f72539?crop=entropy&cs=srgb&fm=jpg&q=85",
  sneakers: "https://images.unsplash.com/photo-1780832000120-23892cd70642?crop=entropy&cs=srgb&fm=jpg&q=85",
  cap: "https://images.unsplash.com/photo-1648114359508-8596f8f2f3fc?crop=entropy&cs=srgb&fm=jpg&q=85",
  tshirt: "https://images.unsplash.com/photo-1759572095317-3a96f9a98e2b?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const MERCH_STORE_URL = "https://the33rd.store";

export const CONTACT = {
  email: "request.quote@cold-blooded-records.info",
  support: "support@cold-blooded-records.com",
  phones: ["(256) 579-0956", "(803) 634-9027", "(803) 900-2564"],
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img
    src="/logo-coin.png"
    alt="DGE: Cold-Blooded Records LLC™ logo"
    className={`${className} rounded-full object-cover`}
    draggable="false"
  />
);
